export const UNKNOWN_IDENTITY = 'unknown';
export const NORMALIZED_EMAIL_ATTRIBUTE = 'data-email-service';
export const CHAT_IDENTIFIER_SEPARATOR = '.';
export const ADVANCED_SUPPORT_GROUP_ID = 'bfda6e14-8a9e-4256-b357-18da6a60e696';
export const BASIC_SUPPORT_GROUP_ID = '6815c234-acb9-444c-8639-6e3ea01cfdd6';
export const MEMBERSHIP_SUPPORT_GROUP_ID = '10446e06-dad1-46c7-97c6-43e1bedeb005';
